import { PartialVLF } from 'components/Search/types';
import { buildSavedSearchParams } from 'components/Search/functions';
import { MULTI_SELECT_FIELDS } from 'components/Search/const';

/**
 * Parse a saved search payload into filters format
 * @param ssPayload - The saved search payload object
 * @param defaultFilters - Default filters to merge with parsed filters
 * @returns Parsed filters in PartialVLF format
 */
export const parseSavedSearchToFilters = (
  ssPayload: any,
  defaultFilters: PartialVLF,
): PartialVLF => {
  // Convert saved search payload to filters format
  const savedSearchParamsString = buildSavedSearchParams({
    payload: ssPayload,
  });

  // Parse the query string to extract filters
  const params = new URLSearchParams(savedSearchParamsString);
  const parsedFilters: PartialVLF = {};

  params.forEach((value, key) => {
    // Check if this field should be an array and value contains commas
    if (MULTI_SELECT_FIELDS.includes(key) && value.includes(',')) {
      // Split comma-separated values into array
      parsedFilters[key] = value.split(',');
    } else {
      parsedFilters[key] = value;
    }
  });

  return {
    ...defaultFilters,
    ...parsedFilters,
  };
};
